import { IOWidget, Action, mk_widget, mk_pair } from 'widgets-for-react'
import * as React from 'react'

import { FormState } from '../../../../gravityform/types'
import { formWidget } from '../../../../gravityform/index'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { CMSState } from '../../../../cms/blocks/types.gen'

export type GravityFormBlockProps = {
  blockIndex: number
  formId: string
  state: FormState
}

export type GravityFormBlockStyle = Partial<{
  blockClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  contentClassName: string
}>

export function GravityFormBlock<customBlockData, extra_images>(
  props: GravityFormBlockProps,
  options?: { style?: GravityFormBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<customBlockData, extra_images, never>>> {
  return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: (setState) => (
        <section className="block block--form block--gravity-form" id="form-block">
          <div className='block__inner container container--s spacing--m gutter--m'>
            <header className='block__header block__header--spacing'>
              {props.state.form_data.kind != 'loaded' ? (
                <></>
              ) : (
                <h2 className='block__title typo--l ff--primary'>
                  {props.state.form_data.value.form.title}
                </h2>
              )}
            </header>
            <div className="block__content">
              {formWidget(props.state).run((futureState) => {
                let newState = futureState(props.state)
                // if (newState.form_submission_logic.kind === 'loaded')
                //   if (!window._mtm.find((layer) => layer.action === 'Form'))
                //     window._mtm.push({
                //       event: `event.${window.site.Name}`,
                //       category: 'Contact',
                //       action: 'Form',
                //       label: window.location.pathname
                //     })

                setState((s) => {
                  let currentBlock = s.blocks.get(props.blockIndex) as any
                  if (currentBlock === undefined) return s
                  if (currentBlock.kind === 'gravityFormBlock') {
                    currentBlock = {
                      ...currentBlock,
                      value: mk_pair(
                        { ...currentBlock.value.fst, state: { ...newState, route_state: 'none' } },
                        currentBlock.value.snd
                      )
                    }
                  }
                  return { ...s, blocks: s.blocks.set(props.blockIndex, currentBlock) }
                })
              })}
            </div>
          </div>
        </section>
      )
    })
}
